export enum DiskSpacePropertyEnum {
  USED = 'used',
  MAX = 'max'
}
